module.exports = __webpack_public_path__ + "img/opera.3b4d41e9.svg";